module.exports = __webpack_public_path__ + "static/img/cloud-icon.7bb3c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cloud-icon.png
// module id = YgO6
// module chunks = 1